import { Link, useParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { getFormationBySlug } from '../data/formations';
import '../styles/FormationDetailPage.css';

function FormationDetailPage() {
  const { slug } = useParams();
  const formation = getFormationBySlug(slug);
  const isIaFormation = formation?.slug === 'automatisation-ia';
  const handleFormationClick = () => {
    if (formation?.preRedirectAlert) {
      alert(formation.preRedirectAlert);
    }
  };

  if (!formation) {
    return (
      <div>
        <Navbar />
        <main className="formation-detail-page">
          <div className="formation-detail-container">
            <p className="formation-badge">Formation introuvable</p>
            <h1 className="formation-detail-title">Cette formation n'existe pas.</h1>
            <Link to="/" className="btn btn-primary">Retour à l'accueil</Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <Navbar />
      <main className="formation-detail-page">
        <div className="formation-detail-container">
          <p className="formation-badge">Détail de formation</p>
          <h1 className="formation-detail-title">{formation.title}</h1>
          <p className="formation-detail-description">{formation.longDescription}</p>

          {isIaFormation && (
            <section className="formation-video-section">
              <h2>Présentation video</h2>
              <div className="formation-video-wrapper">
                <video controls preload="metadata" className="formation-video-player">
                  <source src={`${process.env.PUBLIC_URL}/presentation-school-ia.mp4`} type="video/mp4" />
                  Votre navigateur ne supporte pas la lecture video.
                </video>
              </div>
            </section>
          )}

          <div className="formation-detail-meta">
            <div className="formation-meta-item">
              <span className="formation-meta-label">Prix</span>
              {formation.oldPrice ? (
                <p className="formation-price-promo">
                  <span className="formation-old-price">{formation.oldPrice}</span>
                  <strong className="formation-new-price">{formation.price}</strong>
                </p>
              ) : (
                <strong>{formation.price}</strong>
              )}
            </div>
            <div className="formation-meta-item">
              <span className="formation-meta-label">Niveau</span>
              <strong>{formation.level}</strong>
            </div>
          </div>

          <section className="formation-section">
            <h2>Objectifs</h2>
            <ul>
              {formation.goals.map((goal) => (
                <li key={goal}>{goal}</li>
              ))}
            </ul>
          </section>

          <section className="formation-section">
            <h2>Programme</h2>
            <ul>
              {formation.program.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>

          <div className="formation-actions">
            {/* <Link to="/" className="btn btn-outline back-home-btn">Retour au site</Link> */}
            <a
              href={formation.formationLink}
              className="btn btn-primary"
              onClick={handleFormationClick}
            >
              Payer en une fois
            </a>
            {formation.formationInstallmentLink && (
              <a href={formation.formationInstallmentLink} className="btn btn-outline formation-installment-btn">
                {formation.installmentLabel || 'Payer en 4x'}
              </a>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default FormationDetailPage;
